import React from 'react';
import NotificacaoForm from './NotificacaoForm';
//import $ from 'jquery';
import momentTZ from 'moment-timezone';

import api from '../../../services/api';

export default class Notificacao extends React.Component
{
    constructor(props) {
        super(props);
        this.search();
        this.state = {
            notifications: []
        }
    }

    search = () => {
        var self = this;
        api.get('/admin/json/notificacao')
        .then((data) => {
            if(data.length) {
                self.setState({
                    notifications: data
                })
            }
        });
    }

    render() {
        const {notifications} = this.state;
        return (
            <div className="Notificacao row">
                <div className="col-md-12 header-page p-3">
                    <h2 className="title">
                        Notificação
                        <div className="d-inline-block ml-4">
                            <button className="btn btn-sm btn-success" 
                             data-toggle="modal" 
                             data-target="#novaNotificacaoForm" 
                            >
                                Nova Notificação
                            </button>
                        </div>
                    </h2>
                    <NotificacaoForm elementId="novaNotificacaoForm" refresh={this.search} />
                </div>
                <div className="col-md-12">
                    <div className="card border-0 mt-4">
                        <div className="card-body">
                            <table className="table">
                                <tbody>
                                {notifications.map(notification => (
                                    <tr key={notification.id}> 
                                        <td>{notification.title}</td>
                                        <td>{momentTZ.tz(notification.created, 'America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss')}</td>
                                        <td>{notification.body}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
